import { PLURALL_DOMAINS } from './constants'

const getCookieLoggedName = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'pull_request':
      return 'development_shared_cookie'
    case 'development':
      return 'development_shared_cookie'
    case 'staging':
      return 'staging_shared_cookie'
    case 'production':
      return 'shared_cookie'
    default:
      return 'development_shared_cookie'
  }
}

const getEnvironmentName = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'production':
      return 'production'
    case 'development':
      return 'development'
    case 'staging':
      return 'staging'
    default:
      return 'development'
  }
}

const getToken = () => {
  const r = document.cookie.match(`\\b${getCookieLoggedName()}=([^;]*)\\b`)
  return r ? r[1] : undefined
}

const setToken = (token: string) => {
  const sharedCookieName = getCookieLoggedName()
  document.cookie = `${sharedCookieName}=${token};path=/;domain=.plurall.net`
}

const clearToken = () => {
  const sharedCookieName = getCookieLoggedName()

  PLURALL_DOMAINS.forEach(domain => {
    document.cookie = `${sharedCookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`
  })
}

export { getToken, setToken, clearToken, getCookieLoggedName, getEnvironmentName }
